import { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { Form, Popover, Button, Space } from 'antd'
import { MoreOutlined } from '@ant-design/icons'
import { ListSearch, Scrollbars, LoadableButton, FormPropsContext, ListPropsContext } from 'src/components'
import { searchStore, listStore } from 'src/stores'
import { $consts } from 'src/plugins'
import { getValidBtns } from '../helper'

const ListBtns = observer((props: { formCode: string }) => {
  const formProps = useContext(FormPropsContext)
  const table = listStore.table.get(props.formCode)

  // 批量保存按钮弹窗列表
  const batchAddBtn = useMemo(() => {
    const fromWhere = formProps.formData?.fromWhere
    const matchListHeader = (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_HEADER']
      && fromWhere?.funcType === $consts['TABLE/FUNC_TYPE_BATCH_SAVE']
      && fromWhere?.funcData
    )
    const matchEditHeader = (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_EDIT_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_HEADER']
      && fromWhere?.funcType === $consts['TABLE/FUNC_TYPE_BATCH_SAVE']
      && fromWhere?.funcData
    )
    return matchListHeader || matchEditHeader
  }, [formProps.formData?.fromWhere])

  const btns = useMemo(() => {
    if (!table?.tableConfig?.Btns?.length) return []

    return getValidBtns(table.tableConfig.Btns).sort((a, b) => a.NUM - b.NUM)
  }, [table?.tableConfig?.Btns])

  // 超过多少按钮数时将其收进更多按钮
  const sliceCount = table?.tableConfig?.Nav_Table?.SHOW_BTN_COUNT || btns.length

  // 批量保存按钮弹窗列表
  if (batchAddBtn) {
    return (
      <LoadableButton
        pageType={$consts['TABLE/FORM_TYPE_LIST_PAGE']}
        locateBtn={$consts['TABLE/BTN_LOCATE_HEADER']}
        config={{ ...batchAddBtn, BTN_TYPE: $consts['TABLE/BTN_TYPE_BATCH_SAVE'] }}
      />
    )
  }

  if (!btns.length) return <div />

  return (
    <div className='display-flex flex-rowfsfs'>
      <Form layout='inline' className='list-page__header-btns'>
        {
          btns.slice(0, sliceCount).map((btn, index) => {
            const style = index === btns.length - 1 ? { marginRight: 0 } : {}
            return (
              <Form.Item key={btn.ID} style={style}>
                <LoadableButton
                  pageType={$consts['TABLE/FORM_TYPE_LIST_PAGE']}
                  locateBtn={$consts['TABLE/BTN_LOCATE_HEADER']}
                  config={btn}
                />
              </Form.Item>
            )
          })
        }
      </Form>
      {
        btns.length > sliceCount
          ? (
            <Popover
              trigger={['click']}
              placement='bottomRight'
              content={
                <Form layout='horizontal'>
                  {
                    btns.slice(sliceCount).map((btn, index, arr) => {
                      const style = index === arr.length - 1 ? { marginBottom: 0 } : {}
                      return (
                        <Form.Item key={btn.ID} style={style}>
                          <LoadableButton
                            pageType={$consts['TABLE/FORM_TYPE_LIST_PAGE']}
                            locateBtn={$consts['TABLE/BTN_LOCATE_HEADER']}
                            config={btn}
                          />
                        </Form.Item>
                      )
                    })
                  }
                </Form>
              }
            >
              <Space.Compact>
                <Button>更多操作</Button>
                <Button icon={<MoreOutlined />} />
              </Space.Compact>
            </Popover>
          )
          : null
      }
    </div>
  )
})

const ListPageHeader = () => {
  const listProps = useContext(ListPropsContext)
  const search = searchStore.search.get(listProps.formCode)
  const table = listStore.table.get(listProps.formCode)

  const visible = useMemo(() => {
    return search?.searchConfig?.Nav_FormQuery?.length || table?.tableConfig?.Btns?.length
  }, [search?.searchConfig, table?.tableConfig])

  return (
    <div className={visible ? 'border-bottom' : ''}>
      <Scrollbars autoHeight>
        <div className='list-page__header'>
          <ListSearch
            preventAutoConfig
            formCode={listProps.formCode}
          />
          <ListBtns formCode={listProps.formCode} />
        </div>
      </Scrollbars>
    </div>
  )
}

export default observer(ListPageHeader)